import { AppLogo } from "@/components/ui/AppLogo";

export function Hero() {
  return (
    <div className="text-center py-16">
      <div className="flex justify-center mb-6">
        <AppLogo size="lg" priority />
      </div>
      <div className="w-24 h-px bg-[--olive] mx-auto mb-6" />
      <p className="text-xl md:text-2xl text-[--text-secondary] max-w-2xl mx-auto">
        asking why since 2020
      </p>
      <p className="text-[--text-muted] mt-4 max-w-lg mx-auto">
        A developer's journey through curiosity, code, and creation.
        150+ blogs. Open source tools. One question at a time.
      </p>
    </div>
  );
}
